import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c9ac72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message-sender-name"
}
const _hoisted_2 = {
  key: 0,
  class: "alias"
}

import { showSenderName } from "@/utils/message";
import { AudioMessage, Message, TextMessage } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { computed } from "vue";
import { getPhoneContactUserAliasFromId } from "@/utils/users";

interface ChatMessageSenderProps {
  message: TextMessage | AudioMessage;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessageSender',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const contactUserAlias = computed<string | undefined>(() =>
  getPhoneContactUserAliasFromId(props.message.senderId),
);

const contactUserAliasText = computed<string>(
  () => `~${contactUserAlias.value}`,
);

return (_ctx: any,_cache: any) => {
  return (_unref(showSenderName)(_ctx.visibleMessages, _ctx.index, _unref(authId)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.message.senderName), 1),
        (contactUserAlias.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(contactUserAliasText.value), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})